// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBAlrYebKn2iX40DprDRN0L45_N1Ao0PIk",
  authDomain: "bctalk-app.firebaseapp.com",
  projectId: "bctalk-app",
  storageBucket: "bctalk-app.appspot.com",
  messagingSenderId: "272874713691",
  appId: "1:272874713691:web:261cae83ca35289566857e",
  measurementId: "G-CDYF7HVGSX",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const messaging = getMessaging(app);

export { messaging };
